import React, { Fragment } from 'react';
import { Container, ListItem, Paper, Typography, Grid, List } from '@material-ui/core';
import DisplayCard from './DisplayCard';
import './card.css';
import { makeStyles } from '@material-ui/core';
import Slider from 'react-slick';



const settings = {
    draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 1000,
    dots: true,
    speed: 500,
    arrows: false,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,

          touchThreshold: 1000,
        },
      },

      {
        breakpoint: 805,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,

          touchThreshold: 1000,
        },
      },

      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,

          touchThreshold: 1000,
        },
      },

      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,

          touchThreshold: 1000,
        },
      },
    ],
  };

const useStyle = makeStyles((theme)=>({
    root:{
        display:"block",
        [theme.breakpoints.up("md")]:{
          display:"inherit",
        }
      },
    mob:{
        // display:"block",
        // [theme.breakpoints.down("md")]:{
        //   display:"block",
        // }
    }
}))


const data = [
    {
        title1: "MOUNTAIN",
        title2: "WATER",
        title3: "STREAM",
        image: "/asserts/images/total/image1.png",
    },
    {
        title1: "JUNGLE",
        title2: "BON ",
        title3: "FIRE",
        image: "/asserts/images/total/image2.png",
    },
    {
        title1: "BEST",
        title2: "ORGANIC",
        title3: "CAFE",
        image: "/asserts/images/total/image3.png",
    },
    {
        title1: "ORGANIC",
        title2: "VEGGIE",
        title3: "GARDEN",
        image: "/asserts/images/total/image4.png",
    },
    
    
    
]

const dataSet = [
    {
        title1: "Label 1",
        title2: "Label 1",
        title3: "Label 1",
        image: "https://picsum.photos/400/509",
    },
    {
        title1: "Label 1",
        title2: "Label 1",
        title3: "Label 1",
        image: "https://picsum.photos/400/510",
    },
    {
        title1: "Label 1",
        title2: "Label 1",
        title3: "Label 1",
        image: "https://picsum.photos/400/511",
    },
    {
        title1: "Label 1",
        title2: "Label 1",
        title3: "Label 1",
        image: "https://picsum.photos/400/512",
    },
    
]


export default function AmeCard() {
    const classes = useStyle();
  return (
    <Fragment>

  
            <Grid container
            style={{justifyContent:"center"}}
            className={classes.root}
            spacing={4}
            alignContent="flex-end"
            
            >
                 {/* <Slider {...settings}>
      <div>
        <h3>1</h3>
      </div>
      <div>
        <h3>2</h3>
      </div>
      <div>
        <h3>3</h3>
      </div>
      <div>
        <h3>4</h3>
      </div>
      <div>
        <h3>5</h3>
      </div>
      <div>
        <h3>6</h3>
      </div>
    </Slider> */}

              {data.map((item)=>{
                  return(
                      <div className="test">

                          <DisplayCard title1={item.title1} title2={item.title2} title3={item.title3} image={item.image} />
                      </div>
                  );
                })}
                {/* <Slider {...settings}>
              </Slider> */}

            



            </Grid>

    </Fragment>
  );
}

export{data};